export const DIGITAL_DISPATCH_UPDATES_GROUP_PREFIX = 'digitaldispatchupdatesdispatchid';
export const DIGITAL_DISPATCH_ALL_DISPATCH_POST_APPROVAL_EVENTS_GROUP = 'digitaldispatchpostapprovaleventsall';
export const DIGITAL_DISPATCH_LIVE_UPDATE_TYPE_DISPATCH_STATUS = 'dispatchstatus';
export const DIGITAL_DISPATCH_LIVE_UPDATE_TYPE_POSTAPPROVAL_STATUS = 'postapproval';
export const DIGITAL_DISPATCH_LIVE_UPDATE_TYPE_LOCATION_STATUS = 'locationupdate';
export const DIGITAL_DISPATCH_LIVE_UPDATE_PROVIDER_ACCEPT = 'provideraccepted';
